export function ProgressBar({ currentStep, totalSteps }) {
  const pct = Math.round((currentStep / totalSteps) * 100);

  return (
    <div className="progress-header">
      <div className="progress-meta">
        <span>Onboarding Progress</span>
      </div>
      <div className="progress-track">
        <div className="progress-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
